module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAaCAYAAADSbo4CAAAACXBIWXMAAAsSAAALEgHS3X78AAABC0lEQVRIie2XvUoDQRRGz/y4sCBLOp/ASsUllWjAV7Gy8XVEn8DeVxDBtAmLlWlFxG4xhEhmRibZiI7a3k2xpxm4zT0w883cUfdH+yMEUfAOXJ8Mq5vvXdWkfxgkRWrrqU3ABC4Gw+pqXbe5V5Ie5B8GMsdUh3PgS0SLWjQUi99tWxH5i04kRVwkZmOuAwG2744PynVdPZelWHxr43nNPJlX8T5xcx2MCTw6xcBKSUSiROEUOzHCYBqxPeBMfGsaiSWF0/RWUe61flh1srZOJ5LSiaR0IikbI2Kf8sUGaIDdnYk+N//SnRGa2WSqV1OInWnR38QP3rb8ckgCbu1L5sZtiRjUBLg8fahGnzqLSPCLs5m0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/seat/seatSoldR.png
// module id = ZcmA
// module chunks = 1